import { Model } from '@models/model';

export class BrandDomains extends Model {
  idDomain: number;
  idZone: string;
  ipAddress: string;
  name: string;
}
